import gql from 'graphql-tag'

export default gql`
    mutation UpdateLoginEmail($email: String!) {
        updateLoginEmail(email: $email)
    }
`
